<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">UX/UI Design</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>UX/UI Design</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/news-7.jpg.webp" alt="UX/UI Design" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">UI/UX Design</h2>
                        <p class="box-text mb-30">The design process of web application development involves creating
                            the visual and interactive elements of the application, focusing on the user interface (UI)
                            and user experience (UX) aspects. It encompasses various stages and activities to ensure an
                            intuitive, visually appealing, and user-friendly web application.
                        </p>
                        <h2 class="box-title">Why UI/UX Design Important?</h2>
                        <div class="sv-gallery-wrapper">
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 mb-5">
                                    <p>Here are the key steps involved in the design process:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul>
                                            <li>Information architecture</li>
                                            <li>Wireframing</li>
                                            <li>Visual design</li>
                                            <li>Prototyping</li>
                                            <li>Responsive design</li>
                                            <li>Usability testing</li>
                                            <li>Iterative design</li>
                                            <li>Style guide and design assets</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>By following a systematic design process, web application development teams can
                                        create visually appealing, intuitive, and user-centric designs that enhance the
                                        overall user experience.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>